// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__1t7Bt","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__XbJvL"};